import type { ConsentPreferences } from '@/components/ConsentBanner.vue'

const CONSENT_KEY = 'idi-fly-consent'

export function getStoredConsent(): ConsentPreferences | null {
  try {
    const stored = localStorage.getItem(CONSENT_KEY)
    if (stored) {
      return JSON.parse(stored) as ConsentPreferences
    }
  } catch {
    // Invalid stored consent
  }
  return null
}

export function hasUserConsented(): boolean {
  return getStoredConsent() !== null
}

export function getConsentPreference(key: keyof ConsentPreferences): boolean {
  const consent = getStoredConsent()
  if (!consent) return false
  return Boolean(consent[key])
}

export function clearConsent(): void {
  localStorage.removeItem(CONSENT_KEY)
}

// Check if specific tracking is allowed
export const isTrackingAllowed = {
  errorTracking: () => getConsentPreference('errorTracking'),
  performanceMonitoring: () => getConsentPreference('performanceMonitoring'),
  sessionReplay: () => getConsentPreference('sessionReplay'),
  userIdentification: () => getConsentPreference('userIdentification'),
}
